import {FormState, UseFormSetError} from "react-hook-form";
import {useMemo} from "react";
import {useErrorMapper} from "@web-libs/util/errors/error-to-string";

export const _useServerError = (formState:FormState<any>, setError:UseFormSetError<any>) => {

    const [submissionErrorHandler, setSubmissionErrorHandler] = useErrorMapper();

    const handleServerError = (error: unknown) => {
        if (submissionErrorHandler) {
            const serverError = submissionErrorHandler(error)
            setError("root.serverError", {
                type: "ServerError",
                message: serverError
            });
        }
    }

    const serverError = useMemo(() => {
        return formState.errors.root?.["serverError"]?.message as string;
    }, [formState]);

    return {serverError, setSubmissionErrorHandler, handleServerError};
}
